/**
 * O alvo da seleção da tela de menções (2026-10-20) — um lugar só pra
 * "o que está selecionado", que o lote, o reprocessamento, o descarte em
 * massa e o resumo da seleção compartilham. Estava inline na página; o
 * resumo da seleção seria a quarta cópia, e uma cópia que divergisse
 * contaria um conjunto diferente do que o lote vai corrigir.
 *
 * Duas formas, e o servidor distingue pelo corpo:
 * - "todas do filtro": o recorte da tela viaja na querystring e o
 *   servidor resolve os ids NO CLIQUE;
 * - seleção marcada: os ids no corpo, mais o escopo em que foram
 *   marcados (é o escopo que diz ao servidor que uma menção de
 *   concorrente pode estar entre eles).
 */

import type { BulkTarget, MentionQuery } from "@/shared/api/api-client";

export type SelectionState = {
  selectAllFiltered: boolean;
  selected: ReadonlySet<number>;
  scope: MentionQuery["scope"];
  /** O recorte da tela, montado só quando "todas do filtro" o pede. */
  buildQuery: () => MentionQuery;
};

export function selectionTarget({
  selectAllFiltered,
  selected,
  scope,
  buildQuery
}: SelectionState): BulkTarget {
  return selectAllFiltered ? { query: buildQuery() } : { mentionIds: [...selected], scope };
}

/**
 * Uma chave que muda quando o CONJUNTO selecionado muda. Serve ao painel
 * de resumo pra saber que a contagem na tela ficou velha — sem recarregar
 * sozinho, porque cada consulta custa um passe por até 50 mil menções.
 * "Todas do filtro" vale pelo recorte (`queryKey`); marcadas valem pelos
 * ids, em ordem, pra marcar e desmarcar a mesma menção não parecer mudança.
 */
export function selectionKey(
  selectAllFiltered: boolean,
  selected: ReadonlySet<number>,
  scope: MentionQuery["scope"],
  queryKey: string
): string {
  if (selectAllFiltered) return `all|${queryKey}`;
  return `ids|${scope ?? "own"}|${[...selected].sort((a, b) => a - b).join(",")}`;
}
